import { Component, ElementRef, ViewChild, inject } from "@angular/core";
import { Pages } from "@constants/pages/Pages";
import { SearchKeyword } from "@models/workspace/SearchKeyword";
import { ThirdPartyDataService } from "@pages/thirdparty/services/ThirdPartyDataService";
import { BaseHighchartWidget } from "../BaseHighchartWidget";
import { firstValueFrom } from "rxjs";
import { provideTranslocoScope } from "@jsverse/transloco";

@Component({
    selector: "thirdparty-widget",
    templateUrl: "../highchart-widget.component.html",
    styleUrls: ["../highchart-widget.component.scss"],
    providers: [provideTranslocoScope("dashboard")]
})
export class ThirdPartyWidgetComponent extends BaseHighchartWidget {
    @ViewChild("chartContainer") chartContainer: ElementRef;

    private thirdpartyDS = inject(ThirdPartyDataService);
    private pages = inject(Pages);

    constructor() {
        super();

        this.globalFilterWorkspaceColumns[this.filterKeys.GlobalFilter.Organization] =
            "OrganizationResponsibleID";

        this.globalFilterWorkspaceColumns[this.filterKeys.GlobalFilter.BusinessDimension] =
            "BusinessDimensionIds";
    }

    protected async getChartConfig() {
        await this.preloadDashboardScope();

        const filters = this.getFilters();
        const data = await firstValueFrom(this.thirdpartyDS.getWidgetInfo(filters));
        
        this.config.noData = !data || !data.some(tpScore => tpScore.y > 0)
        if (this.config.noData) {
            return null;
        }

        const mappedData = [
            <any>{
                colorByPoint: true,
                data,
            },
        ];

        const config = this.getBaseChartConfig(null, mappedData);
        config.legend = { enabled: false };
        config.xAxis = {
            type: "category",
        };

        config.yAxis = {
            allowDecimals: false,
            title: {
                text: this.transloco.translate("dashboard.thirdPartyWidget.yAxisTitle"),
            },
        };

        config.tooltip = {
            headerFormat: "<b>{point.key}:</b> {point.y}",
            pointFormat: "",
        };

        return config;
    }

    protected async openWorkspace(ev: Highcharts.PointClickEventObject) {
        const type = ev.point.options.name.toString();

        const searchKeywords: SearchKeyword[] = [this.getSearchKeyword("Review score", type)];

        const preset = await this.getBasePreset(searchKeywords);
        this.openPreset(this.pages.Thirdparty, preset);
    }

    protected async onGlobalOpenClick() {
        const preset = await this.getBasePreset();
        this.openPreset(this.pages.Thirdparty, preset);
    }
}
